import { mainApi } from "../services/main/api";

const extendedApi = mainApi.injectEndpoints({
    endpoints: builder => ({
        getExpandedComps: builder.query<GetExpandedCompsResponse, GetExpandedCompsRequest>({
            query: (request: GetExpandedCompsRequest) => ({
                url: "getExpandedComps",
                body: request,
                method: "POST",
            }),
        }),
    }),
    overrideExisting: true,
});

export const { useGetExpandedCompsQuery, useLazyGetExpandedCompsQuery } = extendedApi;

export interface GetExpandedCompsRequest {
    businessUseCase: string;
    appealArtifactId: string;
    approachType: string;
    subjectIdentifier: string;
}

export enum ApproachType {
    INCOME = "INCOME",
    SALES = "SALES",
}

export interface ExpandedComp {
    city: string;
    askingRent: number;
    county: string;
    rentType: string;
    propertyClass: string;
    yearBuilt: number;
    pdfPageS3Keys: string[];
    recordId: string;
    landToBuildingRatio: string;
    leaseType: string;
    landSize: string | number;
    leaseEndDate: string;
    enable: boolean;
    propertyType: string;
    state: string;
    zip: string;
    address: string;
    buildingSize: number;
    averageStoryHeight: number;
    uiEnabled: boolean;
    sfLeased: number;
    parcelNumber: string;
    condition: string;
    distanceFromSource: number;
    leaseTermLength: string;
    leaseStartDate: string;
}

export interface GetExpandedCompsResponse {
    appealArtifactId: string;
    expandedCompsDetails: ExpandedComp[];
}

export interface Comp {
    recordId: string;
    uiEnabled?: boolean;
    enable?: boolean;

    [key: string]: any;
}

export interface CompsObject {
    [key: string]: Comp;
}

export interface PendingChanges {
    added: Set<string>;
    removed: Set<string>;
}
